import { css, Theme } from '@emotion/react';
import styled from '@emotion/styled';

import { outlineButtonStyles } from '@/components/common/Button/variants';
import { OutlineButton, PrimaryButton } from '@/components/common/Button/style';
import { pageSectionLayout } from '@/styles/pageLayout';

/** 페이지 상단·카드 내 주요 액션 버튼 행 (결제/등록/확인 등) */
export const PageActionRow = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${({ theme }) => theme.scale.spaceSm};
	width: 100%;

	@media screen and (max-width: 640px) {
		flex-direction: column;

		& > button,
		& > a {
			width: 100%;
		}
	}
`;

export { PrimaryButton, OutlineButton };

/** 목록·표 내 보조 액션 (영수증, 다운로드 등) */
export const TableActionButton = styled(OutlineButton)`
	min-height: 4rem;
	padding: 0 1.2rem;
	font-size: ${({ theme }) => theme.fontSize.sizeSm};
`;

/** 링크형 아웃라인 버튼 (파일 다운로드 등) */
export const OutlineLinkButton = styled.a`
	${({ theme }) => outlineButtonStyles(theme)};
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: ${({ theme }) => theme.scale.space2xs};
	text-decoration: none;
`;

const inlineRowBase = (theme: Theme) => css`
	display: flex;
	flex-wrap: nowrap;
	align-items: stretch;
	gap: ${theme.scale.spaceSm};
	width: 100%;

	& > div {
		flex: 1 1 0;
		min-width: 0;
		width: auto;
	}

	& > button {
		flex: 0 0 auto;
		align-self: stretch;
	}

	& > span {
		flex: 0 0 auto;
		display: inline-flex;
		align-items: center;
		align-self: stretch;
		padding: 0 0.2rem;
		font-size: ${theme.fontSize.sizeMd};
		color: ${theme.ui.text.secondary};
	}
`;

/** 이메일 — 아이디 @ 도메인 선택 */
export const EmailRow = styled.div`
	${({ theme }) => inlineRowBase(theme)}

	& > div:nth-of-type(1),
	& > div:nth-of-type(2) {
		flex: 1 1 0;
		min-width: 8rem;
	}

	& > div:nth-of-type(3) {
		flex: 0 0 16rem;
	}

	@media screen and (max-width: 640px) {
		flex-wrap: wrap;

		& > div:nth-of-type(3) {
			flex: 1 1 100%;
		}
	}
`;

export const FormPage = styled.div`
	${pageSectionLayout}
	display: flex;
	flex-direction: column;
`;

export const Form = styled.form`
	display: flex;
	flex-direction: column;
	gap: ${({ theme }) => theme.scale.space2xl};
	width: 100%;
`;

export const FormActions = styled.div`
	display: flex;
	justify-content: flex-end;
	width: 100%;
`;
